import { WORKSPACE_PRODUCT_FRAGMENT } from 'features/product/api/fragment'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data } from './types'

export const GET_WORKSPACE_PRODUCTS: TypedDocumentNode<Data> = gql`
  ${WORKSPACE_PRODUCT_FRAGMENT}

  query getWorkspaceProducts {
    workspaceProducts {
      ...WorkspaceProductFragment
    }
  }
`
